import { render, staticRenderFns } from "./templateCom.vue?vue&type=template&id=90220954&scoped=true&"
import script from "./templateCom.vue?vue&type=script&lang=ts&"
export * from "./templateCom.vue?vue&type=script&lang=ts&"
import style0 from "./templateCom.vue?vue&type=style&index=0&id=90220954&scoped=true&lang=scss&"
import style1 from "./templateCom.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90220954",
  null
  
)

export default component.exports